import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import Manifesto from "@/sections/Manifesto";
import Why from "@/sections/Why";
import HowItWorks from "@/sections/HowItWorks";
import TheFive from "@/sections/TheFive";
import Matchmaker from "@/sections/Matchmaker";
import Feedback from "@/sections/Feedback";
import MyDate from "@/sections/MyDate";
import Membership from "@/sections/Membership";
import Trust from "@/sections/Trust";

function useAfterCurtain() {
  const { state } = useLocation();
  const [ready, setReady] = useState(!state?.curtain);
  useEffect(() => {
    if (ready) return undefined;
    const t = setTimeout(() => setReady(true), 2400);
    return () => clearTimeout(t);
  }, [ready]);
  return ready;
}

export default function HomePage() {
  const ready = useAfterCurtain();
  return (
    <>
      <Hero />
      <Manifesto />
      {ready ? (
        <>
          <Why />
          <HowItWorks />
          <TheFive />
          <Matchmaker />
          <Feedback />
          <MyDate />
          <Membership />
          <Trust />
        </>
      ) : (
        <div aria-hidden="true" className="h-[120vh] bg-ivory" />
      )}
    </>
  );
}
